module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks is given here for great help from the living and the dead, and from the shadows between these worlds. Among the first of this influential group are my friend Jeffrey Essman, the actor and writer, who is perhaps not a lapsed Catholic; my friend and dear editor, Jane Chelius, who one day on a train ride along the Atlantic coast of Spain encouraged me to write from the heart; and my wife, Kim Sykes, who is no less than the hope of me. The poet William Butler Yeats, who often worried that his verses might inspire the darker angels of man, died in 1939. Excerpts from his “Remorse for Intemperate Speech” and “A Full Moon in March” (published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Collected Poems of William Butler Yeats,")]), _vm._v(" Macmillan, New York, 1956) are used herein, with gratitude. The beautiful plays of the late Brendan Behan (1923-64), the borstal boy himself, first taught me to listen to personal ghosts dwelling in Irish shadows. And so I did in writing this.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Thomas Adcock")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2885afbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm3.vue
// module id = 72
// module chunks = 0